/**
 * 管理端  客户管理
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <sysNav></sysNav>
      <!-- 主体内容 -->

      <!-- 个人资料 -->
      <div id="personData" class="eval-content">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>个人资料</div>
            <div class="eval-con-btn" style="margin-left: auto;" @click="showEditPsd()">修改密码</div>
         </div>
         <div>
            <el-form :model="adminInfoForm" class="eval-form" label-width="80px" style="padding-bottom: 10px;text-align: left;">
               <div style="display: flex;">
                  <el-form-item label="姓名：" prop="name">
                     <el-input size="small"  v-model.trim="adminInfoForm.name" auto-complete="off" clearable style="width: 450px;" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="角色：" prop="role_name" style="margin-left: 60px;">
                     <el-input size="small"  v-model.trim="adminInfoForm.role_name" auto-complete="off" clearable style="width: 450px;" disabled></el-input>
                  </el-form-item>
               </div>
               <div style="display: flex;">
                  <el-form-item label="电话：" prop="mobile">
                     <el-input size="small"  v-model.trim="adminInfoForm.mobile" auto-complete="off" clearable style="width: 450px;" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="邮箱：" prop="email" style="margin-left: 60px;">
                     <el-input size="small"  v-model.trim="adminInfoForm.email" auto-complete="off" clearable style="width: 450px;" disabled></el-input>
                  </el-form-item>
               </div>
            </el-form>
         </div>
      </div>
      <!-- 系统配置 -->
      <div id="systemConfig" class="eval-content" v-if="permissionBtnAuth" style="margin-top: 20px;">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>系统配置</div>
            <div class="eval-con-btn" style="margin-left: auto;" @click="showEditSysConfig()">新增配置</div>
            <div class="eval-con-search">
               <el-input v-model.trim="formInlineConfig.search" clearable placeholder="请输入关键词">
                  <el-button slot="append" style="color: #ffffff;" @click="searchConfig()">搜索</el-button>
               </el-input>
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="sysConfigData" highlight-current-row v-loading="loadingConfig" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="code" align="center" label="code值" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="value" align="center" label="value值" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="name" align="center" label="名称" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="note" align="center" label="备注" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="type" align="center" label="类型" width="60" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.type == 1">文字</span>
                     <span v-if="scope.row.type == 2">图片</span>
                     <span v-if="scope.row.type == 3">表格</span>
                  </template>
               </el-table-column>
               <el-table-column prop="admin_name" align="center" label="操作人" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                     <el-button size="mini" type="primary" style="background-color: #2A91DD;" @click="showEditSysConfig(scope.row)">编辑</el-button>
                     <!-- <el-button size="mini" type="primary">删除</el-button> -->
                  </template>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparmConfig" @callFather="callFatherConfig"></Pagination>
         </div>
      </div>
      <!-- 权限菜单管理 -->
      <div id="authMenu" class="eval-content" v-if="sysConfigBtnAuth" style="margin-top: 20px;">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>权限菜单</div>
            <div class="eval-con-btn" style="margin-left: auto;" @click="showEditPermission()">新增菜单</div>
            <div class="eval-con-search">
               <el-input v-model.trim="formInlinePermission.search" clearable placeholder="请输入关键词">
                  <el-button slot="append" style="color: #ffffff;" @click="searchPermission()">搜索</el-button>
               </el-input>
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="permissionData" highlight-current-row v-loading="loadingPermission" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="permission_name" align="center" label="菜单名称" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="type" align="center" label="类型" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.type == 1">菜单</span>
                     <span v-if="scope.row.type == 2">按钮</span>
                  </template>
               </el-table-column>
               <el-table-column prop="flag" align="center" label="签名" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                     <el-button size="mini" style="background-color: #2A91DD;" type="primary" @click="showEditPermission(scope.row)">编辑</el-button>
                     <el-button size="mini" type="danger" @click="delPermissionAuth(scope.row)">删除</el-button>
                  </template>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparmPermission" @callFather="callFatherPermission"></Pagination>
         </div>
      </div>
      <!-- 角色管理 -->
      <div id="roleData" class="eval-content" v-if="roleManageBtnAuth" style="margin-top: 20px;">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>角色管理</div>
            <div class="eval-con-btn" style="margin-left: auto;" @click="showEditRole()">新增角色</div>
            <div class="eval-con-search">
               <el-input v-model.trim="formInlineRole.search" clearable placeholder="请输入关键词">
                  <el-button slot="append" style="color: #ffffff;" @click="searchRole()">搜索</el-button>
               </el-input>
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="sysRoleData" highlight-current-row v-loading="loadingRole" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="role_name" align="center" label="角色名称" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                     <!-- <el-button size="mini" style="background-color: #2A91DD;" type="primary" :disabled="scope.row.role_id==1" @click="showEditRole(scope.row)">编辑</el-button> -->
                     <el-button size="mini" style="background-color: #2A91DD;" type="primary" @click="showEditRole(scope.row)">编辑</el-button>
                     <el-button size="mini" type="danger" :disabled="scope.row.role_id==1" @click="delRoleAuth(scope.row)">删除</el-button>
                  </template>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparmRole" @callFather="callFatherRole"></Pagination>
         </div>
      </div>
      <!-- 评估订单管理 -->
      <div id="caseOrder" class="eval-content" v-if="evalCaseOrderBtnAuth" style="margin-top: 20px;">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>评估订单管理</div>
            <!-- <div class="eval-con-btn" style="margin-left: auto;" @click="showEditPermission()">新增菜单</div> -->
            <div class="title-flex-end">
               <div class="areaPicker">
                  <span style="color: #606266;font-size: 14px;">支付时间：</span>
                  <el-date-picker
                        v-model="evalOrderDate"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        format="yyyy.MM.dd"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                  </el-date-picker>
                  <span class="clearBtn" style="margin-left: 4px;" title="清除时间" @click="clearEvalDate()">清除</span>
               </div>
               <div class="eval-con-search" style="margin-left: 0px;">
                  <el-input v-model.trim="formInlineEval.search"  clearable placeholder="请输入关键词">
                     <el-button slot="append" style="color: #ffffff;" @click="searchEvalOrder()">搜索</el-button>
                  </el-input>
               </div>
                <!-- <el-button type="primary" style="background-color: #2A91DD;" @click="getEvalCaseOrderData()">刷新</el-button> -->
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="evalCaseOrderData" highlight-current-row v-loading="loadingEvalCase" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="title" align="center" label="专利名称" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="appNumber" align="center" label="专利号" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="patentee" align="center" label="专利权人" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="name" align="center" label="用户姓名" width="80" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="company" align="center" label="用户单位" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="total_fee" align="center" label="订单金额(元)" width="90" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="points" align="center" label="消耗积分" width="80" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="status" align="center" label="订单状态" width="80" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.status == 1">未支付</span>
                     <span v-if="scope.row.status == 2">已支付</span>
                  </template>
               </el-table-column>
               <!-- <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
               </el-table-column> -->
               <el-table-column prop="pay_time" align="center" label="支付时间" width="120" show-overflow-tooltip>
               </el-table-column>
               <!-- <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                     <el-button size="mini" type="primary" :disabled="scope.row.role_id==1" @click="showEditRole(scope.row)">编辑</el-button>
                     <el-button size="mini" type="danger" :disabled="scope.row.role_id==1" @click="delRoleAuth(scope.row)">删除</el-button>
                  </template>
               </el-table-column> -->
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparmEval" @callFather="callFatherEval"></Pagination>
         </div>
      </div>
      <!-- 充值订单管理 -->
      <div id="rechargeOrder" class="eval-content" v-if="rechargeOrderBtnAuth" style="margin-top: 20px;">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>充值订单管理</div>
            <div class="title-flex-end">
                <div class="areaPicker">
                  <span style="color: #606266;font-size: 14px;">支付时间：</span>
                  <el-date-picker
                        v-model="rechargeDate"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        format="yyyy.MM.dd"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                  </el-date-picker>
                  <span class="clearBtn" style="margin-left: 4px;" title="清除时间" @click="clearRechargeDate()">清除</span>
               </div>
               <div class="eval-con-search" style="margin-left: 0px;">
                  <el-input v-model.trim="formInlineRecharge.search"  clearable placeholder="请输入关键词">
                     <el-button slot="append" style="color: #ffffff;" @click="searchRechargeOrder()">搜索</el-button>
                  </el-input>
               </div>
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="rechargeOrderData" highlight-current-row v-loading="loadingRecharge" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="name" align="center" label="用户姓名" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="company" align="center" label="用户单位" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="total_fee" align="center" label="订单金额(元)" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="points" align="center" label="充值积分" width="120" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="pay_type" align="center" label="支付方式" width="120" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.pay_type==1">微信</span>
                     <span v-if="scope.row.pay_type==2">支付宝</span>
                     <span v-if="scope.row.pay_type==3">对公转账</span>
                     <span v-if="scope.row.pay_type==4">扫码转账</span>
                  </template>
               </el-table-column>
               <el-table-column prop="status" align="center" label="订单状态" width="120" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.status==1||scope.row.status==4">未支付</span>
                     <span v-if="scope.row.status==2" style="color: #67C23A;">已支付</span>
                     <span v-if="scope.row.status==3" title="已上传转账凭证,等待平台审核" style="color: #2A91DD;cursor: pointer;" @click="showExamineTransfer(scope.row)">待审核</span>
                  </template>
               </el-table-column>
               <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="pay_time" align="center" label="支付时间" show-overflow-tooltip>
               </el-table-column>
               <!-- <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                     <el-button size="mini" type="primary" :disabled="scope.row.role_id==1" @click="showEditRole(scope.row)">编辑</el-button>
                     <el-button size="mini" type="danger" :disabled="scope.row.role_id==1" @click="delRoleAuth(scope.row)">删除</el-button>
                  </template>
               </el-table-column> -->
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparmRecharge" @callFather="callFatherRecharge"></Pagination>
         </div>
      </div>
      <!-- 发票申请管理 -->
      <div id="ticketApply" class="eval-content" v-if="applyTicketBtnAuth" style="margin-top: 20px;">
         <div class="eval-con-top">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>发票申请管理</div>
            <!-- <div class="eval-con-btn" style="margin-left: auto;" @click="showEditPermission()">新增菜单</div> -->
            <div class="title-flex-end">
                <div class="areaPicker">
                  <span style="color: #606266;font-size: 14px;">申请时间：</span>
                  <el-date-picker
                        v-model="ticketDate"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        format="yyyy.MM.dd"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                  </el-date-picker>
                  <span class="clearBtn" style="margin-left: 4px;" title="清除时间" @click="clearTicketDate()">清除</span>
               </div>
               <div class="eval-con-search" style="margin-left: 0px;">
                  <el-input v-model.trim="formInlineApply.search"  clearable placeholder="请输入关键词">
                     <el-button slot="append" style="color: #ffffff;" @click="searchApplyTicket()">搜索</el-button>
                  </el-input>
               </div>
            </div>
         </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="applyTicketData" highlight-current-row v-loading="loadingApply" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="name" align="center" label="用户姓名" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="company" align="center" label="用户单位" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="invoice_name" align="center" label="发票抬头" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="invoice_ein" align="center" label="发票税号" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="total_fee" align="center" label="发票金额(元)" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="type" align="center" label="发票类型" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.type==1">增值税普通发票</span>
                     <span v-if="scope.row.type==2">增值税专用发票</span>
                  </template>
               </el-table-column>
               <el-table-column prop="status" align="center" label="状态" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.status==1" title="查看开票信息并上传发票" style="color: #F56C6C;cursor: pointer;" @click="showUploadTicket(scope.row)">未开票</span>
                     <span v-if="scope.row.status==2" title="查看已开发票" style="color: #67C23A;cursor: pointer;" @click="viewTicket(scope.row.bill_url)">已开票</span>
                  </template>
               </el-table-column>
               <el-table-column prop="add_time" align="center" label="申请时间" show-overflow-tooltip>
               </el-table-column>
               <!-- <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                     <el-button size="mini" type="primary" :disabled="scope.row.role_id==1" @click="showEditRole(scope.row)">编辑</el-button>
                     <el-button size="mini" type="danger" :disabled="scope.row.role_id==1" @click="delRoleAuth(scope.row)">删除</el-button>
                  </template>
               </el-table-column> -->
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparmApply" @callFather="callFatherApply"></Pagination>
         </div>
      </div>

      <!-- 修改密码 -->
      <div class="edit-password">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editPsdVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ title }}</div>
            <el-form :model="passwordForm" style="margin-top: 30px;">
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>新密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.password" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>重复密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.passwords" clearable></el-input>
               </div>
               <el-button style="width: 100%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitPassword()">确认修改</el-button>
            </el-form>
         </el-dialog>
      </div>
      <!-- 系统配置编辑 -->
      <div class="edit-customer">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editSysConfigVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ configTitle }}</div>
            <el-form :model="editConfigForm" style="margin-top: 30px;">
               <div style="margin-top: 10px;">
                  <div style="text-align: left;" prop="name"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>code值</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="editConfigForm.code" :disabled="editConfigForm.action==2" placeholder="请填写code" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;" prop="value"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>value值类型</div>
                  <div style="margin-top: 6px;margin-bottom: 6px;">
                     <el-radio v-model="editConfigForm.type" label="1" style="margin-left: -130px;">文字</el-radio>
                     <el-radio v-model="editConfigForm.type" label="2">图片</el-radio>
                     <el-radio v-model="editConfigForm.type" label="3">表格</el-radio>
                  </div>
                  <div v-if="editConfigForm.type==2" style="display: flex;width: 100%;margin-bottom: 4px;">
                     <div style="background-color: #2A91DD;color: #ffffff;border-radius: 4px;padding: 4px;cursor: pointer;width: 50%;">
                        <el-upload
                           class="upload-demo"
                           :action=uploadImgAction
                           :show-file-list="false"
                           :headers=setHeader
                           :before-upload="beforeUploadImg"
                           :on-success="handleUploadImgSuccess"
                           >
                           <span style="padding: 4px 10px; background-color: #2A91DD;color: #fff;border-radius: 4px;cursor: pointer;" title="选择需要上传的图片">上传图片</span>
                        </el-upload> 
                     </div>
                     <div style="background-color: #2A91DD;color: #ffffff;border-radius: 4px;padding: 4px;cursor: pointer;width: 50%;margin-left: 20px;" @click="viewImg()">查看图片</div>
                  </div>
                  <div v-if="editConfigForm.type==3" style="display: flex;width: 100%;margin-bottom: 4px;">
                     <div style="background-color: #2A91DD;color: #ffffff;border-radius: 4px;padding: 4px;cursor: pointer;width: 50%;">
                        <el-upload
                           class="upload-demo"
                           :action=uploadExcelAction
                           :show-file-list="false"
                           :headers=setHeader
                           :before-upload="beforeUploadExcel"
                           :on-success="handleUploadExcelSuccess"
                           >
                           <span style="padding: 4px 10px; background-color: #2A91DD;color: #fff;border-radius: 4px;cursor: pointer;" title="选择需要上传的表格">上传表格</span>
                        </el-upload> 
                     </div>
                     <div style="background-color: #2A91DD;color: #ffffff;border-radius: 4px;padding: 4px;cursor: pointer;width: 50%;margin-left: 20px;" @click="downloadExcel()">下载表格</div>
                  </div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="editConfigForm.value" :disabled="editConfigForm.type!=1" placeholder="请填写value" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>名称</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="editConfigForm.name" placeholder="请填写名称" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>备注</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="editConfigForm.note" placeholder="请填写备注" clearable></el-input>
               </div>
               <el-button style="width: 100%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitSysConfig()">确认添加</el-button>
            </el-form>
         </el-dialog>
      </div>
      <!-- 权限菜单编辑 -->
      <div class="edit-customer">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editPermissionVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ configTitle }}</div>
            <el-form :model="editPermissionForm" style="margin-top: 30px;">
               <div style="margin-top: 10px;">
                  <div style="text-align: left;" prop="name"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>菜单名称</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="editPermissionForm.permission_name" placeholder="请填写菜单名称" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;" prop="permission_index">前端路由</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="editPermissionForm.permission_index" placeholder="请填写前端路由" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>类型</div>
                  <el-select v-model="editPermissionForm.type" placeholder="请选择类型" style="width: 100%;margin-top: 4px;" filterable clearable>
                        <el-option
                           v-for="item in typeData"
                           :key="item.value"
                           :label="item.name"
                           :value="item.value"></el-option>
                     </el-select>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;">签名</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="editPermissionForm.flag" placeholder="请填写签名" clearable></el-input>
               </div>
               <el-button style="width: 100%;margin-top: 20px;" type="primary" @click="commitPermission()">确认添加</el-button>
            </el-form>
         </el-dialog>
      </div>
      <!-- 系统角色编辑 -->
      <div class="edit-customer">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editRoleVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ roleTitle }}</div>
            <el-form :model="editRoleForm" style="margin-top: 30px;">
               <div style="margin-top: 10px;">
                  <div style="text-align: left;" prop="name"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>角色名称</div>
                  <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="editRoleForm.role_name" placeholder="请填写角色名称" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;" prop="name"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>菜单权限</div>
                  <el-form-item>
                        <el-tree class="treeclass" 
                                 ref="menuTree" 
                                 :data="menuAuthData" 
                                 default-expand-all
                                 :props="defaultProps"
                                 :default-checked-keys="checkMenu"
                                 node-key="permission_id" 
                                 check-on-click-node
                                 show-checkbox>
                        </el-tree>
                  </el-form-item>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;" prop="name"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>按钮权限</div>
                     <el-tree class="treeclass" 
                              ref="btnTree" 
                              :data="btnAuthData" 
                              default-expand-all
                              :props="defaultProps"
                              :default-checked-keys="checkBtn"
                              node-key="permission_id" 
                              check-on-click-node
                              show-checkbox>
                     </el-tree>
               </div>
               <el-button style="width: 100%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitRole()">确认添加</el-button>
            </el-form>
         </el-dialog>
      </div>
      <!-- 对公转账凭证审核 -->
      <div class="edit-customer">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="examineTransferVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">审核转账凭证</div>
               <el-form :model="examineTransferForm" style="margin-top: 30px;">
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">用户姓名：{{ examineTransferForm.name }}</div>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">用户电话：{{ examineTransferForm.mobile }}</div>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">用户单位：{{ examineTransferForm.company }}</div>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">转账金额：￥{{ examineTransferForm.total_fee }}</div>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">
                        <span style="padding: 4px 10px; background-color: #2A91DD;color: #fff;border-radius: 4px;cursor: pointer;" @click="viewVoucher()">查看凭证</span>
                     </div>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">
                        <span style="color: #999999;">注：请仔细辨别凭证是否重复审核过，以及是否到账</span>
                     </div>
                  </div>
                  <div style="margin-top: 2px;">
                     <div style="text-align: left;">
                        <span style="color: #999999;">注：审核通过表示凭证无误且已到账</span>
                     </div>
                  </div>
                  <div>
                     <el-button style="width: 45%;margin-top: 20px;" type="danger" @click="commitExamine(1)">审核不通过</el-button>
                     <el-button style="width: 45%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitExamine(2)">审核通过</el-button>
                  </div>
               </el-form>
         </el-dialog>
      </div>
      <!-- 上传发票 -->
      <div class="edit-customer">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="uploadTicketVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">开具发票并上传</div>
            <el-form style="margin-top: 30px;">
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">发票抬头：<span style="cursor: pointer;" title="点击复制" @click="copyText(applyTicketForm.invoice_name)">{{ applyTicketForm.invoice_name }}</span></div>
                  </div>
                  <div style="margin-top: 10px;" v-if="applyTicketForm.invoice_ein">
                     <div style="text-align: left;">发票税号：<span style="cursor: pointer;" title="点击复制" @click="copyText(applyTicketForm.invoice_ein)">{{ applyTicketForm.invoice_ein }}</span></div>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" v-if="applyTicketForm.type == 1">发票类型：增值税普通发票</div>
                     <div style="text-align: left;" v-if="applyTicketForm.type == 2">发票类型：增值税专用发票</div>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">开票金额：￥<span style="cursor: pointer;" title="点击复制" @click="copyText(applyTicketForm.total_fee)">{{ applyTicketForm.total_fee }}</span></div>
                  </div>
                  <div style="margin-top: 10px;" v-if="applyTicketForm.bank">
                     <div style="text-align: left;">开户银行：<span style="cursor: pointer;" title="点击复制" @click="copyText(applyTicketForm.bank)">{{ applyTicketForm.bank }}</span></div>
                  </div>
                  <div style="margin-top: 10px;" v-if="applyTicketForm.bank_account">
                     <div style="text-align: left;">银行账户：<span style="cursor: pointer;" title="点击复制" @click="copyText(applyTicketForm.bank_account)">{{ applyTicketForm.bank_account }}</span></div>
                  </div>
                  <div style="margin-top: 10px;" v-if="applyTicketForm.address">
                     <div style="text-align: left;">注册地址：<span style="cursor: pointer;" title="点击复制" @click="copyText(applyTicketForm.address)">{{ applyTicketForm.address }}</span></div>
                  </div>
                  <div style="margin-top: 10px;" v-if="applyTicketForm.tel">
                     <div style="text-align: left;">注册电话：<span style="cursor: pointer;" title="点击复制" @click="copyText(applyTicketForm.tel)">{{ applyTicketForm.tel }}</span></div>
                  </div>
                  <div style="margin-top: 10px;" v-if="applyTicketForm.email">
                     <div style="text-align: left;">接收邮箱：{{ applyTicketForm.email }}</div>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">
                        <span style="color: #999999;">注：请留意发票类型是普票还是专票</span>
                     </div>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;display: flex;">
                        <el-upload
                        class="upload-demo"
                        :action=uploadTicketAction
                        :show-file-list="false"
                        :limit="1"
                        :headers=setHeader
                        :before-upload="beforeUploadTicket"
                        :on-success="handleUploadTicketSuccess"
                        style="text-align: left;margin-top: 10px;">
                        <span style="padding: 4px 10px; background-color: #2A91DD;color: #fff;border-radius: 4px;cursor: pointer;" title="选择需要上传的发票文件">上传发票</span>
                     </el-upload>
                     <div style="text-align: left;margin-top: 10px;margin-left: 10px;">
                        <span v-if="ticketForm.url" style="padding: 4px 10px; background-color: #FF8B36;color: #fff;border-radius: 4px;cursor: pointer;" @click="viewTicket(ticketForm.url)">查看发票</span>
                     </div>
                     </div>
                  </div>
                  <div>
                     <el-button style="width: 100%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitTicket()">确认提交</el-button>
                  </div>
               </el-form>
         </el-dialog>
      </div>
      <!-- 图片预览 -->
      <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="viewImgVisible" width="600px">
            <img :src="editConfigForm.view_url" style="width: 100%;">
         </el-dialog>
      </div>
      <!-- PDF预览 -->
      <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="viewPDFVisible" width="900px">
            <div v-if="viewPdfType=='pdf'">
               <iframe :src="viewPdfUrl" style="width: 100%;height: 600px;" frameboder="0"></iframe>
            </div>
            <div v-else>
               <img :src="viewPdfUrl" style="width: 100%;">
            </div>
         </el-dialog>
      </div>
    </div>
 </template>
 <script>
   import { 
      changeAdminPassword,
      getAdminInfo,
      getSysConfigPageList,
      editSysConfig,
      delSysConfig,
      getPermissionPageList,
      editPermission,
      delPermission,
      getSysRolePageList,
      editSysRole,
      delSysRole,
      getAuthMenu,
      getRoleInfo,
      getEvalCaseOrderPageList,
      getRechargeOrderPageList,
      getApplyTicketPageList,
      getRechargeOrderInfo,
      examineTransfer,
      editInvoiceTicket,
      webUrl
   } from '../../api/evalMG'
   import md5 from 'js-md5'
   import Pagination from '../../components/Pagination'
   import topInfo from '../../components/topInfo'
   import sysNav from '../../components/sysNav'
   import { checkLogin } from '../../utils/util'
   export default {
      data() {
         return {
            // 按钮权限开始
            permissionBtnAuth: false,
            sysConfigBtnAuth: false,
            roleManageBtnAuth: false,
            evalCaseOrderBtnAuth: false,
            rechargeOrderBtnAuth: false,
            applyTicketBtnAuth: false,
            // 按钮权限结束
            loading: false,
            loadingConfig: false,
            loadingPermission: false,
            loadingRole: false,
            loadingEvalCase: false,
            loadingRecharge: false,
            loadingApply: false,
            editPsdVisible: false,
            editSysConfigVisible: false,
            editPermissionVisible: false,
            editRoleVisible: false,
            examineTransferVisible: false,
            uploadTicketVisible: false,
            viewImgVisible: false,
            viewPDFVisible: false,
            viewExcelVisible: false,
            title: '',
            configTitle: '',
            permissionTitle: '',
            roleTitle: '',
            adminInfoForm: {
               name: '',
               mobile: '',
               role_id: '',
               role_name: '',
               email: ''
            },
            examineTransferForm: {
               order_id: '',
               voucher_url: '',
               total_fee: '',
               name: '',
               mobile: '',
               company: ''
            },
            ticketForm: {
               id: '',
               url: '',
               save_url: ''
            },
            pickerOptions: {
               shortcuts: [{
               text: '最近一周',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
               picker.$emit('pick', [start, end]);
               }
            }, {
               text: '最近一个月',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
               picker.$emit('pick', [start, end]);
               }
            }, {
               text: '最近三个月',
               onClick(picker) {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
               picker.$emit('pick', [start, end]);
               }
            }]
            },
            caseOrderDate: [],
            applyTicketForm: [],
            sysConfigData: [],
            permissionData: [],
            sysRoleData: [],
            // 菜单权限(all)
            menuAuthData: [],
            // 按钮权限(all)
            btnAuthData: [],
            // 菜单权限(checked)
            checkMenu: [],
            // 按钮权限(checked)
            checkBtn: [],
            editConfigForm: {
               id: '',
               code: '',
               value: '',
               name: '',
               note: '',
               type: '',
               view_url: '',
               action: ''
            },
            typeData: [
               {
                  name: '菜单',
                  value: 1
               },
               {
                  name: '按钮',
                  value: 2
               }
            ],
            editPermissionForm: {
               permission_id: '',
               pid: '',
               permission_name: '',
               permission_index: '',
               type: '',
               flag: ''
            },
            editRoleForm: {
               role_id: '',
               role_name: '',
               permission_ids: []
            },
            // 案件订单管理数据
            evalCaseOrderData: [],
            // 充值订单管理数据
            rechargeOrderData: [],
            // 发票申请管理数据
            applyTicketData: [],
            passwordForm: {
               password: '',
               passwords: ''
            },
            formInline: {
               page: 1,
               ps: 10,
               search: ''
            },
            formInlineConfig: {
               page: 1,
               ps: 10,
               search: ''
            },
            formInlinePermission: {
               page: 1,
               ps: 10,
               search: ''
            },
            formInlineRole: {
               page: 1,
               ps: 10,
               search: ''
            },
            evalOrderDate: [],
            formInlineEval: {
               page: 1,
               ps: 10,
               search: '',
               startDate: '',
               endDate: ''
            },
            rechargeDate: [],
            formInlineRecharge: {
               page: 1,
               ps: 10,
               search: '',
               startDate: '',
               endDate: ''
            },
            ticketDate: [],
            formInlineApply: {
               page: 1,
               ps: 10,
               search: '',
               startDate: '',
               endDate: ''
            },
            defaultProps: {
               children: 'children',
               label: 'permission_name'
            },
            setHeader:{
               'token': localStorage.getItem('userToken')
            },
            // 管理员发票上传方法
            uploadTicketAction:webUrl + '/web/admin/uploadTicket',
            // 图片上传方法
            uploadImgAction:webUrl + '/web/admin/uploadImg',
            // 表格上传方法
            uploadExcelAction:webUrl + '/web/admin/uploadExcel',

            // PDF预览地址
            viewPdfUrl: '',
            viewPdfType: false,

            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
            // 分页参数(系统配置)
            pageparmConfig: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
            // 分页参数(权限菜单)
            pageparmPermission: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
            // 分页参数(系统角色)
            pageparmRole: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
            // 分页参数(案件订单)
            pageparmEval: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
            // 分页参数(充值订单)
            pageparmRecharge: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
            // 分页参数(发票申请)
            pageparmApply: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
         }
      },
      // 注册组件
      components: {
         Pagination,
         topInfo,
         sysNav
      },
      created(){
         // 获取账户权限按钮
         let btnAuth = JSON.parse(localStorage.getItem('btnAuth'))
         if(btnAuth.includes("permissionBtn")){
            this.permissionBtnAuth = true
            this.getPermissionData()
         }
         if(btnAuth.includes("sysConfigBtn")){
            this.sysConfigBtnAuth = true
            this.getSysConfigData()
         }
         if(btnAuth.includes("roleManageBtn")){
            this.roleManageBtnAuth = true
            this.getSysRoleData()
         }
         if(btnAuth.includes("evalCaseOrderBtn")){
            this.evalCaseOrderBtnAuth = true
            this.getEvalCaseOrderData()
         }
         if(btnAuth.includes("rechargeOrderBtn")){
            this.rechargeOrderBtnAuth = true
            this.getRechargeOrderData()
         }
         if(btnAuth.includes("applyTicketBtn")){
            this.applyTicketBtnAuth = true
            this.getApplyTicketData()
         }
         this.getAdminInfoData()
         this.getAuthMenuData()
      },
      methods: {
         checkType(val){
            this.applyForm.type = val
         },
         checkArea(val){
            this.applyForm.area = val
         },
        // 跳转客户管理
         jumpCustomer(){
            this.$router.push({ path: '/system/customer'});
         },
         // 跳转账户管理
         jumpAccount(){
            this.$router.push({ path: '/system/account'});
         },
         // 跳转案件管理
         jumpCase(){
            this.$router.push({ path: '/system/case'});
         },
         // 跳转个人中心
         jumpPersonCenter(){
            this.$router.push({ path: '/system/personCenter'});
         },

         // 显示修改密码弹窗
         showEditPsd(){
            this.editPsdVisible = true
            this.invoiceTitle = '修改密码'
         },
         // 提交密码修改
         commitPassword(){
            let password = this.passwordForm.password
            let passwords = this.passwordForm.passwords
            if(password.length <= 0 || passwords.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写必填项!'
               }) 
               return false
            }
            if(password != passwords){
               this.$message({
                  type: 'warning',
                  message: '两次输入密码不一致!'
               }) 
               return false
            }
            let param = {
               password: md5(password)
            }
            changeAdminPassword(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editPsdVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
                  return false
               }
            })
         },
         // 查询管理员账户基本信息
         getAdminInfoData(){
            let param = {}
            getAdminInfo(param)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  this.adminInfoForm.name = res.data.name
                  this.adminInfoForm.mobile = res.data.mobile
                  this.adminInfoForm.role_id = res.data.role_id
                  this.adminInfoForm.role_name = res.data.role_name
                  this.adminInfoForm.email = res.data.email
               }
            })
         },
         // 查询系统配置列表
         getSysConfigData(){
            this.loadingConfig = true
            getSysConfigPageList(this.formInlineConfig)
            .then(res=>{
               if(res.code == 200){
                  this.sysConfigData = res.data.dataList
                  this.pageparmConfig.currentPage = this.formInlineConfig.page
                  this.pageparmConfig.pageSize = this.formInlineConfig.ps
                  this.pageparmConfig.total = res.data.total
                  this.loadingConfig = false
               }else{
                  this.loadingConfig = false
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 系统配置搜索按钮
         searchConfig(){
            this.formInlineConfig.page = 1
            this.getSysConfigData()
         },
         // 显示编辑系统配置弹窗
         showEditSysConfig(val){
            if(val){
               this.configTitle = '编辑系统配置'
               this.editConfigForm.id = val.id
               this.editConfigForm.code = val.code
               this.editConfigForm.value = val.value
               this.editConfigForm.name = val.name
               this.editConfigForm.note = val.note
               this.editConfigForm.type = val.type
               this.editConfigForm.action = 2
            }else{
               this.configTitle = '添加系统配置'
               this.editConfigForm.id = ''
               this.editConfigForm.code = ''
               this.editConfigForm.value = ''
               this.editConfigForm.name = ''
               this.editConfigForm.note = ''
               this.editConfigForm.type = ''
               this.editConfigForm.action = 1
            }
            this.editSysConfigVisible = true
         },
         // 提交系统配置编辑
         commitSysConfig(){
            let data = this.editConfigForm
            if(data.code.length <= 0){
               this.$message({
                  type: 'warning',
                  message: 'code不能为空'
               })
               return false
            }
            if(data.value.length <= 0){
               this.$message({
                  type: 'warning',
                  message: 'value不能为空'
               })
               return false
            }
            if(data.name.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '名称不能为空'
               })
               return false
            }
            if(data.note.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '备注不能为空'
               })
               return false
            }
            editSysConfig(data)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.getSysConfigData()
                  this.editSysConfigVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 查询权限菜单列表
         getPermissionData(){
            this.loadingPermission = true
            getPermissionPageList(this.formInlinePermission)
            .then(res=>{
               if(res.code == 200){
                  this.permissionData = res.data.dataList
                  this.pageparmPermission.currentPage = this.formInlinePermission.page
                  this.pageparmPermission.pageSize = this.formInlinePermission.ps
                  this.pageparmPermission.total = res.data.total
                  this.loadingPermission = false
               }else{
                  this.loadingPermission = false
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 权限菜单搜索按钮
         searchPermission(){
            this.formInlinePermission.page = 1
            this.getPermissionData()
         },
         // 显示编辑权限菜单弹窗
         showEditPermission(val){
            if(val){
               this.permissionTitle = '编辑菜单'
               this.editPermissionForm.permission_id = val.permission_id
               this.editPermissionForm.pid = val.pid
               this.editPermissionForm.permission_name = val.permission_name
               this.editPermissionForm.permission_index = val.permission_index
               this.editPermissionForm.type = val.type
               this.editPermissionForm.flag = val.flag
            }else{
               this.permissionTitle = '添加菜单'
               this.editPermissionForm.permission_id = ''
               this.editPermissionForm.pid = ''
               this.editPermissionForm.permission_name = ''
               this.editPermissionForm.permission_index = ''
               this.editPermissionForm.type = ''
               this.editPermissionForm.flag = ''
            }
            this.editPermissionVisible = true
         },
         // 提交权限菜单
         commitPermission(){
            let data = this.editPermissionForm
            if(data.type.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '类型不能为空!'
               })
               return false
            }
            if(data.permission_name.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '菜单名称不能为空!'
               })
               return false
            }
            if(data.type == 2){
               if(data.flag.length <= 0){
                  this.$message({
                     type: 'warning',
                     message: '签名不能为空!'
                  })
                  return false
               }
            }
            editPermission(data)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.getPermissionData()
                  this.editPermissionVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })

         },
         // 删除权限菜单
         delPermissionAuth(val){
            let permission_id = val.permission_id
            let param = { permission_id }
            this.$confirm('确定删除吗?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               delPermission(param)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                     this.getPermissionData()
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
         },
         // 查询系统角色列表
         getSysRoleData(){
            this.loadingRole = true
            getSysRolePageList(this.formInlineRole)
            .then(res=>{
               if(res.code == 200){
                  this.sysRoleData = res.data.dataList
                  this.pageparmRole.currentPage = this.formInlineRole.page
                  this.pageparmRole.pageSize = this.formInlineRole.ps
                  this.pageparmRole.total = res.data.total
                  this.loadingRole = false
               }else{
                  this.loadingRole = false
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 角色管理搜索按钮
         searchRole(){
            this.formInlineRole.page = 1
            this.getSysRoleData()
         },
         // 显示编辑系统角色弹窗
         showEditRole(val){
            if(val){
               // 查询角色详情
               this.roleTitle = '编辑角色'
               this.editRoleForm.role_id = val.role_id
               this.editRoleForm.role_name = val.role_name
               let param = {
                  role_id: val.role_id
               }
               getRoleInfo(param)
               .then(res=>{
                  if(res.code == 200){
                     this.checkBtn = res.data.btn
                     this.checkMenu = res.data.menu
                     this.editRoleVisible = true
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     })
                  }
               })
            }else{
               this.roleTitle = '添加角色'
               this.editRoleForm.role_id = ''
               this.editRoleForm.role_name = ''
               this.checkBtn = []
               this.checkMenu = []
               this.editRoleVisible = true
            }
            
         },
         // 提交系统角色
         commitRole(){
            let data = this.editRoleForm
            if(data.role_name.length <= 0){
               this.$message({
                  type: 'waraning',
                  message: '角色名称不能为空!'
               })
               return false
            }
            let menuKeys = this.$refs.menuTree.getCheckedKeys().concat(this.$refs.menuTree.getHalfCheckedKeys())
            let btnKeys = this.$refs.btnTree.getCheckedKeys().concat(this.$refs.btnTree.getHalfCheckedKeys())
            if(menuKeys.length <= 0){
              this.$message({
                type: 'error',
                message: '菜单权限不能为空!'
              })
              return false
            }
            if(btnKeys.length <= 0){
               this.$message({
                  type: 'error',
                  message: '按钮菜单不能为空!'
               })
               return false
            }
            data.permission_ids = JSON.stringify(menuKeys.concat(btnKeys))
            editSysRole(data)
            .then(res=>{
               if(res.code == 200){
                  this.getSysRoleData()
                  this.editRoleVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 删除系统角色
         delRoleAuth(val){
            let role_id = val.role_id
            if(role_id == 1){
               this.$message({
                  type: 'warning',
                  message: '超级管理员不能删除!'
               })
               return false
            }
            let param = { role_id }
            this.$confirm('确定删除吗?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               delSysRole(param)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                     this.getSysRoleData()
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
         },
         // 查询全部菜单权限
         getAuthMenuData(){
            let param = {}
            getAuthMenu(param)
            .then(res=>{
               if(res.code == 200){
                  this.menuAuthData = res.data.menu
                  this.btnAuthData = res.data.btn
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 查询案件订单数据
         getEvalCaseOrderData(){
            this.loadingEvalCase = true
            let evalOrderDate = this.evalOrderDate
            if(evalOrderDate&&evalOrderDate.length>0){
               this.formInlineEval.startDate = evalOrderDate[0]
               this.formInlineEval.endDate = evalOrderDate[1]
            }else{
               this.formInlineEval.startDate = ''
               this.formInlineEval.endDate = ''
            }
            getEvalCaseOrderPageList(this.formInlineEval)
            .then(res=>{
               if(res.code == 200){
                  this.evalCaseOrderData = res.data.dataList
                  this.pageparmEval.currentPage = this.formInlineEval.page
                  this.pageparmEval.pageSize = this.formInlineEval.ps
                  this.pageparmEval.total = res.data.total
                  this.loadingEvalCase = false
               }else{
                  this.loadingEvalCase = false
               }
            })
         },
         // 搜索案件订单
         searchEvalOrder(){
            this.formInlineEval.page = 1
            this.getEvalCaseOrderData()
         },
         // 清除案件订单日期
         clearEvalDate(){
            this.evalOrderDate = []
         },
         // 查询充值订单数据
         getRechargeOrderData(){
            this.loadingRecharge = true
            let rechargeDate = this.rechargeDate
            if(rechargeDate&&rechargeDate.length>0){
               this.formInlineRecharge.startDate = rechargeDate[0]
               this.formInlineRecharge.endDate = rechargeDate[1]
            }else{
               this.formInlineRecharge.startDate = ''
               this.formInlineRecharge.endDate = ''
            }
            getRechargeOrderPageList(this.formInlineRecharge)
            .then(res=>{
               if(res.code == 200){
                  this.rechargeOrderData = res.data.dataList
                  this.pageparmRecharge.currentPage = this.formInlineRecharge.page
                  this.pageparmRecharge.pageSize = this.formInlineRecharge.ps
                  this.pageparmRecharge.total = res.data.total
                  this.loadingRecharge = false
               }else{
                  this.loadingRecharge = false
               }
            })
         },
         // 搜索充值订单
         searchRechargeOrder(){
            this.formInlineRecharge.page = 1
            this.getRechargeOrderData()
         },
         // 清除充值订单日期
         clearRechargeDate(){
            this.rechargeDate = []
         },
         // 查询发票申请数据
         getApplyTicketData(){
            this.loadingApply = true
            let ticketDate = this.ticketDate
            if(ticketDate&&ticketDate.length>0){
               this.formInlineApply.startDate = ticketDate[0]
               this.formInlineApply.endDate = ticketDate[1]
            }else{
               this.formInlineApply.startDate = ''
               this.formInlineApply.endDate = ''
            }
            getApplyTicketPageList(this.formInlineApply)
            .then(res=>{
               if(res.code == 200){
                  this.applyTicketData = res.data.dataList
                  this.pageparmApply.currentPage = this.formInlineApply.page
                  this.pageparmApply.pageSize = this.formInlineApply.ps
                  this.pageparmApply.total = res.data.total
                  this.loadingApply = false
               }else{
                  this.loadingApply = false
               }
            })
         },
         // 搜索发票申请
         searchApplyTicket(){
            this.formInlineApply.page = 1
            this.getApplyTicketData()
         },
         // 清除发票申请日期
         clearTicketDate(){
            this.ticketDate = []
         },
         // 显示审核转账凭证弹窗
         showExamineTransfer(val){
            console.log(val)
            this.examineTransferForm.order_id = val.id
            this.examineTransferForm.name = val.name
            this.examineTransferForm.mobile = val.mobile
            this.examineTransferForm.company = val.company
            this.examineTransferForm.total_fee = val.total_fee
            this.examineTransferForm.voucher_url = val.voucher_url
            this.examineTransferVisible = true
         },
         // 查看凭证
         viewVoucher(){
            let url = this.examineTransferForm.voucher_url
            if(url.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '暂无可预览图片'
               })
               return false
            }
            let type = ''
            let parts = url.split('.')
            if(parts.length>1){
               type = parts[parts.length - 1]
            }
            this.viewPdfUrl = url
            this.viewPdfType = type
            this.viewPDFVisible = true
            // window.open(url)
         },
         // 预览图片
         viewImg(){
            let url = this.editConfigForm.view_url
            if(url.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '暂无可预览图片'
               })
               return false
            }
            this.viewImgVisible = true
         },
         // 下载excel
         downloadExcel(){
            let url = this.editConfigForm.view_url
            if(url.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '暂无可下载表格'
               })
               return false
            }
            window.open(url)
         },
         // 审核转账凭证,通过或不通过
         commitExamine(result){
            let data = this.examineTransferForm
            let param = { 
               order_id: data.order_id,
               result: result
             }
            this.$confirm('是否确认核对无误?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               examineTransfer(param)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                     this.getRechargeOrderData()
                     this.examineTransferVisible = false
                  }else{
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
         },
         // 查看发票
         viewTicket(url){
            if(url.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '文件不存在'
               })
               return false
            }
            let type = ''
            let parts = url.split('.')
            if(parts.length>1){
               type = parts[parts.length - 1]
            }
            this.viewPdfUrl = url
            this.viewPdfType = type
            this.viewPDFVisible = true
            // window.open(url)
         },
         // 显示上传发票弹窗
         showUploadTicket(val){
            console.log(val)
            this.uploadTicketVisible = true
            this.applyTicketForm = val
            this.ticketForm.id = val.id
            this.ticketForm.url = ''
            this.ticketForm.save_url = ''
         },
         // 提交发票
         commitTicket(){
            let data = this.ticketForm
            if(!data.id || data.id.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '未选中订单'
               })
               return false
            }
            if(!data.save_url || data.save_url.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请上传发票'
               })
               return false
            }
            editInvoiceTicket(data)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.getApplyTicketData()
                  this.uploadTicketVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 复制文本内容
         copyText(val){
            try {
               navigator.clipboard.writeText(val)
               this.$message({
                  type: 'success',
                  message: '复制成功!'
               })
            } catch (err) {
               this.$message({
                  type: 'error',
                  message: '复制失败,请重试!'
               })
            }
         },
         // 案件订单日期筛选发生变化
         caseOrderDateChange(){

         },
         // 分页插件事件
         callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.ps = parm.pageSize
         },
         // 分页插件事件(系统配置)
         callFatherConfig(parm) {
            this.formInlineConfig.page = parm.currentPage
            this.formInlineConfig.ps = parm.pageSize
            this.getSysConfigData()
         },
         // 分页插件事件(权限菜单)
         callFatherPermission(parm) {
            this.formInlinePermission.page = parm.currentPage
            this.formInlinePermission.ps = parm.pageSize
            this.getPermissionData()
         },
         // 分页插件事件(系统角色)
         callFatherRole(parm) {
            this.formInlineRole.page = parm.currentPage
            this.formInlineRole.ps = parm.pageSize
            this.getSysRoleData()
         },
         // 分页插件事件(案件订单)
         callFatherEval(parm) {
            this.formInlineEval.page = parm.currentPage
            this.formInlineEval.ps = parm.pageSize
            this.getEvalCaseOrderData()
         },
         // 分页插件事件(充值订单)
         callFatherRecharge(parm) {
            this.formInlineRecharge.page = parm.currentPage
            this.formInlineRecharge.ps = parm.pageSize
            this.getRechargeOrderData()
         },
         // 分页插件事件(发票申请)
         callFatherApply(parm) {
            this.formInlineApply.page = parm.currentPage
            this.formInlineApply.ps = parm.pageSize
            this.getApplyTicketData()
         },

         // 文件上传开始
         // 文件上传成功时的钩子
         handleUploadTicketSuccess(response, file, fileList) {
            if(response.code == 200){
               this.$message({
                  type: 'success',
                  message: response.msg
               })
               this.ticketForm.url = response.data.url
               this.ticketForm.save_url = response.data.save_url
            }else{
               this.$message({
                  type: 'error',
                  message: response.msg
               })
            }
         },
         //文件上传前的校验
         beforeUploadTicket(file) {
            const that = this
            if (!/\.(jpg|png|jpeg|JPG|PNG|pdf)$/.test(file.name)) {
               that.$message({
                  type: 'error',
                  message: '请上传图片或者pdf'
               })
               return false
            }
         },
         // 图片上传成功后的方法
         handleUploadImgSuccess(response, file, fileList) {
            if(response.code == 200){
               this.$message({
                  type: 'success',
                  message: response.msg
               })
               this.editConfigForm.value = response.data.save_url
               this.editConfigForm.view_url = response.data.url
            }else{
               this.$message({
                  type: 'error',
                  message: response.msg
               })
            }
         }, 
         //图片上传前的校验
         beforeUploadImg(file) {
            const that = this
            if (!/\.(jpg|png|jpeg|JPG|PNG)$/.test(file.name)) {
               that.$message({
                  type: 'error',
                  message: '请上传图片'
               })
               return false
            }
         },
         // 表格上传成功后的方法
         handleUploadExcelSuccess(response, file, fileList) {
            if(response.code == 200){
               this.$message({
                  type: 'success',
                  message: response.msg
               })
               this.editConfigForm.value = response.data.save_url
               this.editConfigForm.view_url = response.data.url
            }else{
               this.$message({
                  type: 'error',
                  message: response.msg
               })
            }
         }, 
         //表格上传前的校验
         beforeUploadExcel(file) {
            const that = this
            if (!/\.(xlsx|xls)$/.test(file.name)) {
               that.$message({
                  type: 'error',
                  message: '请上传表格'
               })
               return false
            }
         },  

         // 文件上传结束
      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .login-title {
    font-size: 44px;
    font-weight: 700;
    padding-top: 24px;
  }
  .login-title-en {
    font-size: 16px;
    color: #5a5a5a;
    margin-top: 10px;
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 10px 40px;
   padding: 16px 0px;
   border-bottom: 2px solid #eeeeee;
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-con-btn {
   width: 120px;
   height: 40px;
   line-height: 40px;
   text-align: center;
   color: #fff;
   background-color: #FF8B36;
   border-radius: 5px;
   margin-left: 20px;
   cursor: pointer;
  }
  .eval-con-search {
   margin-left: 20px;
  }
  .eval-con-search>>>.el-input-group {
   border-radius: 10px !important;
  }
  .eval-con-search>>>.el-input-group__append, .el-input-group__prepend {
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
  }
  .eval-con-search>>>.el-input__inner {
   background-color: #F3F3F3 !important;
   border: none;
  }
  .eval-table {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-table>>> .el-table__header th {
   background-color: #2A91DD !important;
  }
  .eval-table>>> .el-table thead {
   color: #FFFFFF;
  }

  .eval-form {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-form>>>.el-form-item__label {
   text-align: left !important;
   font-weight: 700 !important;
   padding-left: 10px !important;
  }
  .eval-form>>> .el-input__inner {
   background-color: #F3F3F3 !important;
  }
  .eval-form>>> .el-textarea__inner {
   background-color: #F3F3F3 !important;
   min-height: 80px !important;
  }
  .invoice-item {
   display: flex;
   width: 1120px;
   margin: 0px auto;
   margin-bottom: 20px;
  }
  .invoice-type {
   height: 40px;
   line-height: 40px;
   font-weight: 700;
   color: #FFFFFF;
   background-color: #2A91DD;
   border-radius: 4px;
   padding: 0px 10px;
   font-size: 12px;
  }
  .invoice-label {
   margin-left: 40px;
   height: 40px;
   line-height: 40px;
   font-weight: 700;
   font-size: 12px;
  }
  .invoice-text {
   margin-left: 20px;
   text-align: left;
   height: 40px;
   line-height: 40px;
   background-color: #F3F3F3;
   padding-left: 20px;
   color: #666666;
   border-radius: 4px;
   font-size: 12px;
  }
  /* .edit-invoice>>> .el-dialog__header{
   display: none !important;
  }   */

  .invocie-input{
   background-color: #ECEDF4;
   margin-top: 4px;
  }
  .invoice-btn {
   background-color: #ECEDF4;
   padding: 4px 10px;
   border-radius: 50px;
   width: 50%;
   cursor: pointer;
  }
  .invoice-btn-active {
   background-color: #2A91DD;
   color: #FFFFFF;
  }
 .edit-customer>>>.el-input--suffix .el-input__inner {
    height: 32px !important;
  }
 .edit-customer>>>.el-input__icon{
      height: 32px !important;
      line-height: 32px !important;
   }
 .treeclass {
   margin-top: 8px;
   display: flex !important;
   flex-flow: wrap !important;
   border: 1px solid #f3f3f3;
   padding-top: 20px;
   padding-bottom: 20px;
 }
 .title-flex-end {
   display: flex;
   justify-content: flex-end;
   margin-left: auto;
 }
 .areaPicker {
   margin-top: 2px;
   margin-right: 20px;
 }
 .areaPicker>>>.el-input__inner {
    width: 210px !important;
    height: 40px !important;
    line-height: 40px !important;
    margin-top: -4px !important;
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    padding-left: 20px !important;
    padding-right: 0px !important;
}
.areaPicker>>>i {
    display: none !important;
}
.areaPicker>>>.el-date-editor .el-range-separator {
    line-height: 30px !important;
    color: #999999 !important;
}
.clearBtn {
   padding: 12px 10px;
   border: 1px solid #2A91DD;
   border-radius: 4px;
   color: #ffffff;
   background-color: #2A91DD;
   font-size: 12px;
   cursor: pointer;
}
.excel-table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
}
.excel-table th, .excel-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
.excel-table th {
  background-color: #f2f2f2;
}
</style>


// WEBPACK FOOTER //
// src/views/system/personCenter.vue